import { UpdateVisibilityResponse } from '@/modules/drive/domain/models/ResponseUpdateVisibility'

import { axios, Response } from '../index'

export interface Body {
  id?: string
  name?: string
  folderVisibility?: string
  parentFolderId?: string
}

const updateFolder = (
  personaId: string,
  folderId: string,
  body: Body
): Response<UpdateVisibilityResponse> => {
  return axios.put(`/v1/personas/${personaId}/folders/${folderId}`, body)
}

export default updateFolder
